"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var navigationStyles_1 = require("./navigationStyles");
var Navigation_1 = require("./Navigation");
var useWidgetContext_1 = require("../../../react/useWidgetContext");
var useIsGqlMarket_1 = require("../../../../gql/common/hooks/useIsGqlMarket");
var GqlNavigation_1 = require("./GqlNavigation");
var NavigationContainer = function () {
    var style = navigationStyles_1.default();
    var configuration = useWidgetContext_1.default().configuration;
    var isGqlMarket = useIsGqlMarket_1.default(configuration) || configuration.gqlApi;
    return (<core_1.Grid className={style.backButtonContainer} container data-test="container:navigation">
      {isGqlMarket ? <GqlNavigation_1.default /> : <Navigation_1.default />}
    </core_1.Grid>);
};
exports.default = NavigationContainer;
